import * as React from 'react';
import { cn } from '@/lib/utils';

const Question = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question', className)}
    {...props}
  />
));
Question.displayName = 'Question';

const QuestionBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-body', className)}
    {...props}
  />
));
QuestionBody.displayName = 'QuestionBody';

const QuestionList = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-question-list',
      // 1. LAYOUT & POSICIONAMENTO
      'w-full',
      // 2. RESPONSIVIDADE
      'md:w-[72.5%]',
      className
    )}
    {...props}
  />
));
QuestionList.displayName = 'QuestionList';

const QuestionSidebarWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-question-sidebar-wrapper',
      // 1. LAYOUT PADRÃO (Móvel/Telas Pequenas)
      'static bottom-0 w-full',
      // 2. LAYOUT RESPONSIVO (Desktop: md: >= 768px)
      'md:fixed md:right-12 md:top-[7em] md:w-[17.5%] md:overflow-y-auto md:pb-4',
      className
    )}
    {...props}
  />
));
QuestionSidebarWrapper.displayName = 'QuestionSidebarWrapper';

const QuestionHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-header', 'mb-5 border-b border-solid border-neutral-lighter pb-5', className)}
    {...props}
  />
));
QuestionHeader.displayName = 'QuestionHeader';

const QuestionTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn('c-question-title', 'mb-0 line-clamp-2 text-base font-bold text-primary-dark', className)}
    {...props}
  />
));
QuestionTitle.displayName = 'QuestionTitle';

export { Question, QuestionBody, QuestionList, QuestionSidebarWrapper, QuestionHeader, QuestionTitle };
